import axios from "axios";
import { SERVER } from "../../Constants";

const apiClient = axios.create({
  baseURL: SERVER,
  withCredentials: true,
});

export const uploadVideo = async (file) => {
  const formData = new FormData();
  formData.append("video", file);
  const response = await apiClient.post("/manager/upload-video", formData);
  return response.data;
};

export const getManagerThumbnails = async () => {
  const response = await apiClient.get("/manager/videos/thumbnails");
  return response.data;
};

export const getManagerVideos = async () => {
  const response = await apiClient.get("/manager/videos");
  return response.data;
};

export const deleteVideo = async (id) => {
  const response = await apiClient.delete(`/manager/videos/${id}`);
  return response.data;
};
